import admin from './admin'
import chat from './chat'
import landing from './landing'
import web from './web'

export default {
  web,
  admin,
  landing,
  chat,
  message: {
    hello: 'Hello World',
    loadingFailed: 'Loading failed',
    loadingTip: 'Loading...'
  },
  common: {
    loading: 'Loading...',
    search: 'Search',
    reset: 'Reset',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    back: 'Back',
    success: 'Operation successful',
    error: 'Operation failed',
    required: 'Required',
    pleaseSelect: 'Please select',
    pleaseInput: 'Please input',
    close: 'Close',
    submit: 'Submit',
    operation: 'Operation',
    confirmDelete: 'Are you sure to delete?',
    logo: 'System Logo',
    tooltip: {
      overview: 'Overview',
      aigc: 'AIGC',
      system: 'System Management'
    },
    mobile: {
      menu: 'Menu',
      close: 'Close',
      toggleMenu: 'Toggle Menu'
    }
  },
  components: {
    empty: {
      description: 'No Data',
      noData: 'No Data',
      noResult: 'No Search Results',
      noPermission: 'No Permission'
    },
    upload: {
      clickToUpload: 'Click to Upload',
      dragToUpload: 'Drag files here, or',
      selectFile: 'Select File',
      selected: 'Selected',
      fileTypes: {
        image: 'Image',
        video: 'Video',
        audio: 'Audio',
        document: 'Document'
      }
    },
    userDropdown: {
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout'
    }
  },
  form: {
    validation: {
      email: {
        required: 'Please enter your email',
        invalid: 'Please enter a valid email address'
      },
      password: {
        required: 'Please enter your password',
        minLength: 'Password must be at least 6 characters'
      },
      passwordConfirmation: {
        required: 'Please confirm your password',
        notMatch: 'Passwords do not match'
      }
    }
  },
  error: {
    goHome: 'Go Home',
    messages: {
      500: 'Internal Server Error',
      404: 'Page Not Found',
      403: 'Access Forbidden',
      401: 'Unauthorized Access',
      default: 'An unknown error occurred'
    }
  },
  auth: {
    login: {
      title: 'Login',
      loginAccount: 'Account Login',
      noAccount: 'No account yet?',
      goToRegister: 'Register Now',
      email: 'Email',
      emailPlaceholder: 'Please enter your email',
      password: 'Password',
      passwordPlaceholder: 'Please enter your password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot Password',
      submit: 'Login'
    }
  }
}
